import React from 'react';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const DateTimeSection = ({ 
  birthDate, 
  birthTime, 
  unknownTime, 
  onDateChange, 
  onTimeChange, 
  onUnknownTimeChange,
  errors 
}) => {
  const hours = Array.from({ length: 24 }, (_, i) => ({
    value: i?.toString()?.padStart(2, '0'),
    label: i?.toString()?.padStart(2, '0')
  }));

  const minutes = Array.from({ length: 60 }, (_, i) => ({
    value: i?.toString()?.padStart(2, '0'),
    label: i?.toString()?.padStart(2, '0')
  }));

  return (
    <div className="space-y-5 md:space-y-6">
      <div className="flex items-center space-x-3">
        <div className="w-1 h-8 bg-gradient-to-b from-primary to-secondary rounded-full" />
        <div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground font-thai">
            วันที่และเวลาเกิด
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground mt-1">
            Birth Date and Time
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        <Input
          type="date"
          label="วันที่เกิด"
          placeholder="เลือกวันที่"
          value={birthDate}
          onChange={(e) => onDateChange(e?.target?.value)}
          error={errors?.birthDate}
          required
          className="w-full"
        />

        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-3 md:gap-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2 font-thai">
                ชั่วโมง
                <span className="text-xs text-muted-foreground block mt-0.5">Hour</span>
              </label>
              <select
                value={birthTime?.hour}
                onChange={(e) => onTimeChange({ ...birthTime, hour: e?.target?.value })}
                disabled={unknownTime}
                className="w-full h-12 px-4 py-3 text-sm border-2 border-input rounded-lg bg-card/50 backdrop-blur-sm text-foreground disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all duration-300"
              >
                <option value="" className="text-muted-foreground">เลือกชั่วโมง</option>
                {hours?.map(h => (
                  <option key={h?.value} value={h?.value}>{h?.label}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-2 font-thai">
                นาที
                <span className="text-xs text-muted-foreground block mt-0.5">Minute</span>
              </label>
              <select
                value={birthTime?.minute}
                onChange={(e) => onTimeChange({ ...birthTime, minute: e?.target?.value })}
                disabled={unknownTime}
                className="w-full h-12 px-4 py-3 text-sm border-2 border-input rounded-lg bg-card/50 backdrop-blur-sm text-foreground disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all duration-300"
              >
                <option value="" className="text-muted-foreground">เลือกนาที</option>
                {minutes?.map(m => (
                  <option key={m?.value} value={m?.value}>{m?.label}</option>
                ))}
              </select>
            </div>
          </div>

          {errors?.birthTime && (
            <p className="text-xs md:text-sm text-error mt-1">{errors?.birthTime}</p>
          )}

          <Checkbox
            label="ไม่ทราบเวลาเกิด"
            description="Unknown birth time"
            checked={unknownTime}
            onChange={(e) => onUnknownTimeChange(e?.target?.checked)}
            className="mt-3"
          />
        </div>
      </div>
    </div>
  );
};

export default DateTimeSection;